import type { WebsiteType } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { WebsiteTypeDescription } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";

type SelectionState = {
    isSelected: boolean;
    isPartiallySelected: boolean;
};

export const checkSelection = (
    value: WebsiteType,
    filterValue: readonly WebsiteType[] | undefined = [],
    options: readonly WebsiteTypeDescription[],
): SelectionState => {
    const option = options.find((opt) => opt.value === value);
    const children = option?.options ?? [];

    if (children.length === 0) {
        const isSelected = filterValue.includes(value);
        return { isSelected: isSelected, isPartiallySelected: false };
    }

    const selectedCount = children.filter((child) => filterValue.includes(child)).length;

    return {
        isSelected: selectedCount === children.length,
        isPartiallySelected: selectedCount > 0 && selectedCount < children.length,
    };
};

export const toggleSelection = (
    value: WebsiteType,
    filterValue: readonly WebsiteType[] | undefined = [],
    options: readonly WebsiteTypeDescription[],
): readonly WebsiteType[] => {
    const { isSelected } = checkSelection(value, filterValue, options);
    const children = options.find((opt) => opt.value === value)?.options ?? [value];

    return isSelected
        ? filterValue.filter((opt) => !children.includes(opt))
        : [...new Set([...filterValue, ...children])];
};
